// Alert actions
export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";

// Auth actions
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const GET_PROFILE = "GET_PROFILE";
export const RESET_ALL_STATES = "RESET_ALL_STATES";

// Users actions.
export const ADD_USER = "ADD_USER";
export const GET_ALL_USERS = "GET_ALL_USERS";
export const GET_USER_BY_ID = "GET_USER_BY_ID"; //get user document from the db by is id
export const USER_ERROR = "USER_ERROR";
export const DELETE_USER = "DELETE_USER"; //when admin remove user from the system in the user management page
export const UPDATE_USER = "UPDATE_USER";
export const CLEAR_USER = "CLEAR_USER"; //clear the  selected user data form the state
export const CLEAR_USERS = "CLEAR_USERS"; // clear the users array from the user state section
export const USER_REDUCER_LOADING_USER_TRUE = "USER_REDUCER_LOADING_USER_TRUE";

// Alerts actions.
export const ADD_ALERT = "ADD_ALERT";
export const GET_ALL_ALERTS = "GET_ALL_ALERTS";
export const ALERT_ERROR = "ALERT_ERROR";
export const DELETE_ALERT = "DELETE_ALERT"; //when admin remove user from the system in the user management page
export const CLEAR_ALERT = "CLEAR_ALERT"; //clear the  selected user data form the state
export const CLEAR_ALERTS = "CLEAR_ALERTS"; // clear the users array from the user state section
export const ALERT_REDUCER_LOADING_ALERT_TRUE = "ALERT_REDUCER_LOADING_ALERT_TRUE";
export const ACTIVATE_ALERT = "ACTIVATE_ALERT";
export const DEACTIVATE_ALERT = "DEACTIVATE_ALERT";
export const GET_ALERT_BY_ID = "GET_ALERT_BY_ID";
export const UPDATE_ALERT = "UPDATE_ALERT";

// Scraper actions.
export const ADD_DATA_POINT = "ADD_DATA_POINT";
export const GET_ALL_DATA_POINTS = "GET_ALL_DATA_POINTS";
export const GET_DATA_POINT_BY_ID = "GET_DATA_POINT_BY_ID"; //get user document from the db by is id
export const DATA_POINT_ERROR = "DATA_POINT_ERROR";
export const DELETE_DATA_POINT = "DELETE_DATA_POINT"; //when admin remove user from the system in the user management page
export const UPDATE_DATA_POINT = "UPDATE_DATA_POINT";
export const CLEAR_DATA_POINT = "CLEAR_DATA_POINT"; //clear the  selected user data form the state
export const CLEAR_DATA_POINTS = "CLEAR_DATA_POINTS"; // cleans the arrDataPoints array.
export const DATA_POINT_REDUCER_LOADING_DATA_POINT_TRUE = "DATA_POINT_REDUCER_LOADING_DATA_POINT_TRUE";
export const DATA_POINT_REDUCER_LOADING_ALL_DATA_POINTS = "DATA_POINT_REDUCER_LOADING_ALL_DATA_POINTS";
export const DATA_POINT_REDUCER_LOADING_DATA_POINT_FALSE = "DATA_POINT_REDUCER_LOADING_DATA_POINT_FALSE";

// Adtelligent actions.
export const ADTELLIGENT_GET_DATA_BY_DATE = "ADTELLIGENT_GET_DATA_BY_DATE";
export const ADTELLIGENT_ERROR = "ADTELLIGENT_ERROR";
export const ADTELLIGENT_CHANGE_SELECTED_FATHER_ACCOUNT = "ADTELLIGENT_CHANGE_SELECTED_FATHER_ACCOUNT";
export const ADTELLIGENT_CHANGE_SELECTED_ACCOUNT = "ADTELLIGENT_CHANGE_SELECTED_ACCOUNT";
export const ADTELLIGENT_LOADING_TRUE = "ADTELLIGENT_LOADING_TRUE";
export const ADTELLIGENT_GET_PROGRESS_GRAPH_DATA = "ADTELLIGENT_GET_PROGRESS_GRAPH_DATA";
export const ADTELLIGENT_INITIAL_STATE = "ADTELLIGENT_INITIAL_STATE";
export const ADTELLIGENT_PLATFORM_SET_EXISTING_DATA_GRAPH = "ADTELLIGENT_PLATFORM_SET_EXISTING_DATA_GRAPH";
export const ADTELLIGENT_PLATFORM_SET_EXISTING_DATA = "ADTELLIGENT_PLATFORM_SET_EXISTING_DATA";

// Aggregated actions.
export const AGGREGATED_GET_DATA_BY_DATE = "AGGREGATED_GET_DATA_BY_DATE";
export const AGGREGATED_ERROR = "AGGREGATED_ERROR";
export const AGGREGATED_LOADING_TRUE = "AGGREGATED_LOADING_TRUE";
export const AGGREGATED_INITIAL_STATE = "AGGREGATED_INITIAL_STATE";
export const AGGREGATED_SET_EXISTING_DATA = "AGGREGATED_SET_EXISTING_DATA";

// UI actions.
export const SHOW_SIDEBAR = "SHOW_SIDEBAR";
export const HIDE_SIDEBAR = "HIDE_SIDEBAR";
export const UI_ERROR = "UI_ERROR";
export const SHOW_DIALOG_CHANGE_PASSWORD = "SHOW_DIALOG_CHANGE_PASSWORD";
export const UI_SHOW_DIALOG_SEARCH_SELLER = "UI_SHOW_DIALOG_SEARCH_SELLER";
export const SHOW_GENERAL_LOADER = "SHOW_GENERAL_LOADER";
export const HIDE_GENERAL_LOADER = "HIDE_GENERAL_LOADER";

// dashboard actions.
export const UPDATE_SCRAPED_DATA_DATE = "UPDATE_SCRAPED_DATA_DATE";
export const CHANGE_DATA_POINT_TYPE_FILTER = "CHANGE_DATA_POINT_TYPE_FILTER";

// instances
export const SERVICES_GET_SELLER_DATA_BY_ID = "SERVICES_GET_SELLER_DATA_BY_ID";
export const SERVICES_ERROR = "SERVICES_ERROR";
export const SERVICES_LOADING_TRUE = "SERVICES_LOADING_TRUE";
export const SERVICES_CLEAR_SELLER = "SERVICES_CLEAR_SELLER";

// Roku.
export const ROKU_GET_ALL_CATEGORIES = "ROKU_GET_ALL_CATEGORIES";
export const ROKU_ERROR = "ROKU_ERROR";
export const ROKU_LOADING_SELECTED_CATEGORY_CHANNELS_TRUE = "ROKU_LOADING_SELECTED_CATEGORY_CHANNELS_TRUE";
export const ROKU_LOADING_ALL_CATEGORIES_CREDENTIALS_TRUE = "ROKU_LOADING_ALL_CATEGORIES_CREDENTIALS_TRUE";
export const ROKU_LOADING_SELECTED_CHANNEL_TRUE = "ROKU_LOADING_SELECTED_CHANNEL_TRUE";
export const ROKU_CHANGE_SELECTED_CATEGORY = "ROKU_CHANGE_SELECTED_CATEGORY";
export const ROKU_GET_CATEGORY_CHANNELS_BY_ID = "ROKU_GET_CATEGORY_CHANNELS_BY_ID";
export const ROKU_GET_CHANNEL_DATA_BY_DATES_RANGE_ASYNC = "ROKU_GET_CHANNEL_DATA_BY_DATES_RANGE_ASYNC";

// Platform actions.
export const PLATFORM_GET_DATA_BY_DATE = "PLATFORM_GET_DATA_BY_DATE";
export const PLATFORM_ERROR = "PLATFORM_ERROR";
export const PLATFORM_LOADING_TRUE = "PLATFORM_LOADING_TRUE";
export const PLATFORM_CHANGE_SELECTED_USER = "PLATFORM_CHANGE_SELECTED_USER";
export const PLATFORM_INITIAL_STATE = "PLATFORM_INITIIAL_STATE";
export const PLATFORM_GET_PROGRESS_GRAPH_DATA = "PLATFORM_GET_PROGRESS_GRAPH_DATA";
export const PLATFORM_SET_EXISTING_DATA_GRAPH = "PLATFORM_SET_EXISTING_DATA_GRAPH";
export const PLATFORM_SET_EXISTING_DATA = "PLATFORM_SET_EXISTING_DATA";

// Analytics Actions
export const GET_ANALYTICS_DATA = "GET_ANALYTICS_DATA";
export const SET_ANALYTICS_DATA = "GET_ANALYTICS_DATA";
export const SET_FULL_REPORTS = "SET_FULL_REPORTS";
